import { atom } from "jotai";

export const intentTableEditAtom = atom<{[index: string]: string}>({});
